import type { DmMessageInboxSort } from '../../../services/dmMessagesInbox';
import type { DmInboxStatus } from '../../../services/dmNotifications';
import {
    buildListFilterSummary,
    sortText,
    tagsLine,
    type ListFilterSummary,
    type SharedFilterSources,
    type SortPhrase
} from '../shared/listFilterSummary.ts';
import type { ListSortOrder } from '../shared/listUrlState';

// messagesOrderBy: urgency (the Priority column) and frustration rank highest as largest.
export const MESSAGE_SORT_PHRASES: Readonly<Record<DmMessageInboxSort, SortPhrase>> = {
    latest: { column: 'latest message', desc: 'newest first', asc: 'oldest first' },
    urgency: { column: 'priority', desc: 'highest first', asc: 'lowest first' },
    frustration: { column: 'frustration', desc: 'highest first', asc: 'lowest first' },
    waiting: { column: 'waiting', asc: 'longest waiting first', desc: 'shortest waiting first' }
};

export function messageSortText(sort: DmMessageInboxSort, order: ListSortOrder): string {
    return sortText(MESSAGE_SORT_PHRASES[sort], order);
}

export interface MessageSummarySource {
    shared: SharedFilterSources;
    tags: readonly string[];
    status: DmInboxStatus;
    sort: DmMessageInboxSort;
    order: ListSortOrder;
    total: number | null;
}

export function messageListSummary({
    shared,
    tags,
    status,
    sort,
    order,
    total
}: MessageSummarySource): ListFilterSummary {
    const inboxLines = tagsLine(tags);
    return buildListFilterSummary(shared, inboxLines, total, status, messageSortText(sort, order));
}
